import { getValue } from '@kundinos/nanostores';

import { changeableParametersStore, initialParametersStore } from './stores';

// Кол-во параметров, которые были изменены пользователем
function getCountOfChangedParameters() {
  const initialParameters = getValue(initialParametersStore);
  const changeableParameters = getValue(changeableParametersStore);
  let count = 0;

  changeableParameters.forEach((option) => {
    (option.variants || []).forEach((variant) => {
      const initParam = initialParameters.find((parameter) => {
        return parameter.theme === 'dropdown' && parameter.groupId === option.groupId;
      });

      if (!initParam) return;

      (initParam.variants || []).map((initVariant) => {
        if (!variant.id || initVariant.id !== variant.id) return;
        if (variant.selected && !initVariant.selected) count += 1;
      });
    });
  });

  return count;
}

export default getCountOfChangedParameters;
